export default __webpack_public_path__ + "static/media/iconFirstStep.d435ef24.svg";